<template>
    <div class="page-setting has-bc biz-edit-house">
        <alart-msg :display="alartError.state" styleType="error" @alartStatus="closeAlart()">
            <span class="title" slot="title">{{alartError.msg}}</span>
        </alart-msg>
        <alart-msg :display="alartSuccess.state" styleType="success" @alartStatus="closeAlart()">
            <span class="title" slot="title">{{alartSuccess.msg}}</span>
        </alart-msg>
        <modal class="alarm-orange" :display="modalStatus.editHouse" @modalStatus="closeModal('editHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_orange.svg" alt="">
            <h1>無法上架</h1>
            <div class="content">
                目前有進行中的合約，請先更新最快起租日
            </div>
            <div class="btn-group">
                <button class="default-button" @click="closeModal('editHouse')">編輯房源</button>
            </div>
        </modal>
        <add-equips @setEquips="setNewEquips($event)"></add-equips>
        <modal class="alarm-orange" :display="modalStatus.toOtherPage" @modalStatus="closeModal('toOtherPage')" >
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_orange.svg" alt="">
            <h1>是否保存此頁面</h1>
            <div class="content">
                是否保存目前編輯的頁面，畫面將跳轉至{{toOtherPageInfo.type}}
            </div>
            <div class="btn-group">
                <button class="border-button" @click="closeModal('toOtherPage')">不儲存</button>
                <button class="default-button" @click="toOtherPageSave(toOtherPageInfo.linkName)">儲存</button>
            </div>
        </modal>
        <modal class="delete-house" :display="modalStatus.deleteHouse" @modalStatus="modalStatus.deleteHouse = false" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除房源</h1>
            <div class="content">
                確定刪除“{{editHouse.name}}”的房源嗎？<br>記錄刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteHouse(), $analyticsBiz.logEvent('刪除房源', { screen_name: '刪除房源'})">確認</button>
                <button class="border-button" @click="modalStatus.deleteHouse = false">取消</button>
            </div>
        </modal>
        <share-social-media :cid="$route.query.cid"></share-social-media>
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group" v-if="$route.query.type === 'econtract' || $route.query.type === 'contract' || $route.query.type === 'renewal'">
                <button class="border-button publish" @click="saveEditHouseNoReview()">儲存</button>
            </div>
            <div class="btn-group" v-else>
                <button v-if="bizAuth.previewHouse.hasRight && complete" @click="previewHouse($route.query.cid)" class="new-item-btn preview">
                    <img src="@/assets/img/icon/view_gray.svg" alt="" srcset="">
                    預覽廣告
                </button>
                <button class="border-button publish"  :disabled="houseStatus==2 || taskStatus == 2" v-if="publish" @click="setPublish('HIDE')">下架</button>
                <button class="default-button save" :disabled="houseStatus==2"  v-else-if="tenant.name" @click="saveEditHouseNoReview()">僅儲存</button>
                <button class="border-button save"  :disabled="houseStatus==2" v-else @click="saveEditHouseNoReview()">僅儲存</button>
                <div class="loading-wrap"  v-if="publish">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button save" :disabled="houseStatus==2 || status.isDisable" @click="saveEditHouse()">儲存設定</button>
                </div>
                <div class="loading-wrap"  v-else>
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button publish" :disabled="houseStatus==2 || status.isDisable" @click="saveEditHouse()">儲存並上架</button>
                </div>
                <dot-large-drop-menu bg="#ff9275" bgHover="#eb7859">
                    <ul >
                        <!-- <li>新增電子合約</li>-->
                        <!-- <router-link v-if="houseStatus!=2 && taskStatus != 2 && taskStatus != 1 && complete" :to="{ name: 'NewTask', query: { hid: editHouse.houseCid }}">
                            <li>新增委託</li>
                        </router-link> -->
                        <!--<li>歷代租約</li>
                        <li>歷代評價</li>
                        <li>新增記帳</li> -->
                        <li v-if="bizAuth.shareHouse.hasRight && publish || houseStatus==2" @click="shareSocialMedia(), $analyticsBiz.logEvent('分享房源', { screen_name: '分享房源'})">分享房源</li>
                        <li v-if="bizAuth.deleteHouse.hasRight && houseStatus==1  && taskStatus != 2 && taskStatus != 1" @click="openModal('deleteHouse')">刪除房源</li>
                        <!-- <li>預覽畫面</li> -->

                    </ul>
                </dot-large-drop-menu>
            </div>
        </div>
        <div class="must-fill-alarm">
            <div class="title">
                注意事項：
            </div>
            <div class="list">
                儲存房源時，廣告標題為必填；上架房源時，所有<span class="star">*</span>符號均為必填。
            </div>
        </div>  
        <div class="user-info">
            <span class="title">租客</span>
            <div class="group">
                <span v-if="tenant.name" class="name level1-title-font">
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    租客：{{tenant.name}}
                </span>
                <span v-else class="name level1-title-font">
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    尚未有租客
                </span>
                <div class="status" v-if="complete">
                    狀態：已完善
                </div>
                <div class="status" v-else>
                    狀態：未完善
                </div>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                廣告內容
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-edit-house-type">
                    <div class="section-one">
                        <div class="house-address">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    房源地址
                                </div>
                                <span v-show="error.floorErr" class="error-with-title">{{error.floorErr}}</span>
                            </label>
                            <div class="input-arear">
                                <div class="house-address-wrap">
                                    <rent-select :class="{error: error.cityCidErr}" class="select-scroll biz" ref="county" refName="county" :selectMsg="address.county.msg" :isEdit="editHouse.cityCid?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="address.county.state">
                                        <ul>
                                            <li v-for="(county, index) in counties" :key="index" :data-id="index" :data-name="county">
                                                {{county}}
                                            </li> 
                                        </ul>
                                    </rent-select>
                                    <rent-select @click.native="checkOptionRules('district', '請選擇縣市與區域')" :key="'district'+componentKey" :class="{error: error.districtCidErr}" :isEdit="editHouse.districtCid?true:false" class="select-scroll biz" ref="district" refName="district" :selectMsg="address.district.msg" @getId="getSelectId"  bgColor="#fff" :setDefault="address.district.state">
                                        <ul>
                                            <li v-for="(district, index) in districts" :key="index" :data-id="district.districtCid" :data-name="district.districtName">
                                                {{district.districtName}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select-filter @click.native="checkOptionRules('road', '請選擇縣市與區域')" :key="'road'+componentKey" :class="{error: error.roadStreetCidErr}" :isEdit="editHouse.roadStreetCid?true:false" class="select-scroll select-road biz" refName="road" :selectMsg="address.road.msg" @getId="getSelectId"  bgColor="#fff" :setDefault="address.road.state">
                                        <div class="select-filter">
                                            <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                            <input v-model="filter.road" placeholder="搜尋路段" type="text">
                                        </div>
                                        <ul>
                                            <li v-for="(road, index) in filterRoad" :key="index" :data-id="road.roadStreetCid" :data-name="road.roadStreetName">
                                                {{road.roadStreetName}}
                                            </li>
                                        </ul>
                                    </rent-select-filter>
                                    <div class="lane">
                                        <input type="text" v-model="editHouse.lane">
                                        <span>巷</span>
                                    </div>
                                    <div class="alley">
                                        <input type="text" v-model="editHouse.alley">
                                        <span>弄</span>
                                    </div>
                                    <div class="number">
                                        <input :class="{error: error.numErr}" type="text" v-model="editHouse.number">
                                        <span>號之</span>
                                    </div>
                                    <div class="number">
                                        <input type="text" v-model="editHouse.dash">
                                    </div>
                                    <div class="floor">
                                        <input :class="{error: error.floorErr}" type="text" v-model="editHouse.floor">
                                        <span>樓之</span>
                                    </div>
                                    <div class="room">
                                        <input type="text" v-model="editHouse.room">
                                    </div>
                                </div>
                                <div class="hide-num">
                                    <checkbox v-model="editHouse.isNumberHidden" val="1" msg="隱藏門牌" :isPropChecked="editHouse.isNumberHidden" ></checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section-two">
                        <div class="house-description">
                            <div class="house-name">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        廣告標題
                                    </div>
                                    <span v-show="error.nameErr" class="error-with-title">{{error.nameErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.nameErr}" type="text" v-model="editHouse.name" placeholder="6-20 個字">
                                </div>
                            </div>
                            <div class="house-rent">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房屋租金
                                    </div>
                                    <span v-show="error.rentMonthlyErr" class="error-with-title">{{error.rentMonthlyErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.rentMonthlyErr}" type="text" v-model="editHouse.rentMonthly" placeholder="請輸入金額">
                                </div>
                            </div>
                            <div class="house-intro">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源介紹
                                    </div>
                                    <span v-show="error.desErr" class="error-with-title">{{error.desErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <div class="intro-container">
                                        <!-- <pre class="pre"></pre> -->
                                        <textarea id="edit-description" @keyup="autoGrow()"  :class="{error: error.desErr}" v-model="editHouse.description" placeholder="50-2000 個字" ></textarea>
                                        <span class="des-count"><span class="count">{{editHouse.description.length}}</span>/2000</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="house-setting">
                            <div class="lease-type">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        出租類型
                                    </div>
                                    <span v-show="error.houseTypeErr" class="error-with-title">{{error.houseTypeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.houseTypeErr}" refName="houseType" :selectMsg="editHouse.houseType?houseType[editHouse.houseType-1].itemName:'請選擇出租類型'" :isEdit="editHouse.houseType?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="(house, index) in houseType" :key="index" :data-id="house.houseTypeCode">
                                                {{house.itemName}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div v-if="editHouse.houseType == 1" class="house-pattern four-items">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源格局
                                    </div>
                                </label>
                                <div class="input-arear flex-group">
                                    <rent-select :key="'a'+componentKey" @click.native="checkOptionRules('houseType', '請選擇出租類型')" refName="bedroom" :selectMsg="bedroom" :isEdit="bedroom?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n" :data-id="n-1">
                                                {{n-1}} 房
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select :key="'b'+componentKey" @click.native="checkOptionRules('houseType', '請選擇出租類型')"  refName="sharedRoom" :selectMsg="sharedRoom" :isEdit="sharedRoom?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 廳
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select :key="'c'+componentKey" @click.native="checkOptionRules('houseType', '請選擇出租類型')"  refName="bathroom" :selectMsg="bathroom" :isEdit="bathroom?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 衛浴
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select :key="'d'+componentKey" @click.native="checkOptionRules('houseType', '請選擇出租類型')"  refName="balcony" :selectMsg="balcony" :isEdit="balcony?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="housePattern">
                                        <ul>
                                            <li v-for="n in 11" :key="n-1" :data-id="n-1">
                                                {{n-1}} 陽台
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div v-else class="house-pattern two-items">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源格局
                                    </div>
                                </label>
                                <div class="input-arear flex-group">
                                    <rent-select :key="'e'+componentKey" @click.native="checkOptionRules('houseType', '請選擇出租類型')" refName="hasBalcony" :selectMsg="hasBalcony" :isEdit="hasBalcony?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                                        <ul>
                                            <li data-id="1">
                                                有陽台
                                            </li>
                                            <li data-id="0">
                                                無陽台
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <rent-select :key="'f'+componentKey" @click.native="checkOptionRules('houseType', '請選擇出租類型')" refName="hasDuplex" :selectMsg="hasDuplex" :isEdit="hasDuplex?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="roomPattern">
                                        <ul>
                                            <li data-id="1">
                                                有閣樓
                                            </li>
                                            <li data-id="0">
                                                無閣樓
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div class="house-type">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房屋類型
                                    </div>
                                    <span v-show="error.buildingTypeErr" class="error-with-title">{{error.buildingTypeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.buildingTypeErr}" refName="buildingType" :selectMsg="editHouse.buildingType?buildingType[editHouse.buildingType-1].itemName:'請選擇房屋類型'" :isEdit="editHouse.buildingType?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="(build, index) in buildingType" :key="index" :data-id="build.buildingTypeCode">
                                                {{build.itemName}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div class="house-size">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源坪數
                                    </div>
                                    <span v-show="error.sizeErr" class="error-with-title">{{error.sizeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.sizeErr}" type="number" v-model="editHouse.size" placeholder="輸入房源坪數">
                                </div>
                            </div>
                            <div class="house-special">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        特殊樓層
                                    </div>
                                    <span v-show="error.specialTypeErr" class="error-with-title">{{error.specialTypeErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.specialTypeErr}" refName="specialType" :selectMsg="getSpecialType(editHouse.specialType)" :isEdit="editHouse.specialType?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="(special, index) in specialType" :key="index" :data-id="special.specialTypeCode">
                                                {{special.itemName}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            <div class="house-size">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        房源總樓層
                                    </div>
                                    <span v-show="error.totalFloorErr" class="error-with-title">{{error.totalFloorErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <input :class="{error: error.totalFloorErr}" type="text" v-model="editHouse.totalFloor" placeholder="輸入總樓層">
                                </div>
                            </div>
                            <!-- <div class="house-special">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        最短租期
                                    </div>
                                    <span v-show="error.shortestPeriodErr" class="error-with-title">{{error.shortestPeriodErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.shortestPeriodErr}" refName="shortestPeriod" :selectMsg="editHouse.shortestPeriod?editHouse.shortestPeriod+'個月':'請選擇最短租期'" :isEdit="editHouse.shortestPeriod?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li v-for="n in 12" :key="n" :data-id="n">
                                                {{n}} 個月
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div> -->
                            <div class="house-special">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        繳款方式
                                    </div>
                                    <span v-show="error.payByRentPayDayErr" class="error-with-title">{{error.payByRentPayDayErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.payByRentPayDayErr}" refName="payway" :selectMsg="getPayWayWord(editHouse.payByRentPayDay)" :isEdit="editHouse.payByRentPayDay!=null?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li data-id="contract">
                                                {{getPayWayWord('contract')}}
                                            </li>
                                            <li data-id="date">
                                                {{getPayWayWord('date')}}
                                            </li>
                                        </ul>
                                    </rent-select>
                                    <!-- <div class="input-note" @mouseenter="tipStatus.fixedPayWay=true" @mouseleave="tipStatus.fixedPayWay=false">選擇每月固定繳租的注意事項</div>
                                    <border-tips v-if="tipStatus.fixedPayWay" msg="當選擇每月固定幾號繳租時，我們就不會幫您自動生成第一筆帳單 ( 訂金 30% 以外的 70% 帳單 )" width="424px"></border-tips> -->
                                </div>
                                <span v-if="editHouse.payByRentPayDay" v-show="error.rentPayDayErr" class="error-with-title" style="position: absolute;right: -140px;top: 0px;font-size: 12px;color: #f05a3e;">{{error.rentPayDayErr}}</span>
                                <rent-select v-if="editHouse.payByRentPayDay" class="select-date select-scroll biz" :class="{error: error.rentPayDayErr}" refName="date" :selectMsg="getRentPayDayWord(editHouse.rentPayDay)" :isEdit="editHouse.rentPayDay?true:false" @getId="getSelectId" bgColor="#fff" :setDefault="isDefault">
                                    <ul>
                                        <li v-for="n in 29" :key="n" :data-id="n">
                                            每月 {{n}} 號
                                        </li>
                                        <li :data-id="-1">
                                            每月最後一天
                                        </li>
                                    </ul>
                                </rent-select>
                            </div>
                            <div class="is-with-landlord">
                                <label class="button-font input-label">
                                    <div class="title">
                                        <span class="must-fill">*</span>
                                        與屋主同住
                                    </div>
                                    <span v-show="error.isWithLandlordErr" class="error-with-title">{{error.isWithLandlordErr}}</span>
                                </label>
                                <div class="input-arear">
                                    <rent-select :class="{error: error.isWithLandlordErr}" refName="isWithLandlord" :selectMsg="setIsWithLandLord()" :isEdit="editHouse.isWithLandlord !== null ?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                        <ul>
                                            <li data-id="1">
                                                是
                                            </li>
                                            <li data-id="0">
                                                否
                                            </li>
                                        </ul>
                                    </rent-select>
                                </div>
                            </div>
                            
                        </div>
                        <div class="rent-include">
                            <label class="button-font input-label">
                                <div class="title">
                                    租金包含
                                </div>
                            </label>
                            <div class="wrap">
                                <house-checkbox v-model="houseInclude" v-for="(include, index) in houseRentInclude" :key="index"  :val="include.rentCode" :checkboxMsg="include.itemName" :isPropChecked="include.check" ></house-checkbox>
                            </div>
                        </div>
                        <bill-charge loginType="COMPANY" @error="setBillChargeError"  :includeList="editHouse.rentIncludeList" :editData="billChargeMode" v-model="editHouse.billChargeMode"></bill-charge>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="house-description-title" slot="toogle-title">
                標籤
            </div>
            <div class="biz-edit-house-type" slot="toogle-body">
                <div class="section-two">
                    <div class="rent-include">
                        <label class="button-font input-label">
                            <div class="title">
                                提供設備
                            </div>
                        </label>
                        <div class="wrap">
                            <div class="house-equips h-align" :class="{'odd': index%2 === 0}" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index">
                                <checkbox v-model="editHouse.equipmentList[index].check" :msg="equip.itemName" :val="equip.equipCode" :isPropChecked="editHouse.equipmentList[index].check"></checkbox>
                                <div class="input-arear">
                                    <span class="quantifier">個</span>
                                    <input :class="{'error': error.equipment[index]}" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="editHouse.equipmentList[index].count" placeholder="請輸入數量">
                                </div>
                            </div>
                            <div class="house-equips new-equips" @click="$store.dispatch('setModalStatus', {state: true, type: 'bizAddEquips'})">
                                新增設備
                            </div>
                            <!-- <house-checkbox v-model="houseEquip" v-for="(equip, index) in houseEquips" :key="'houseEquips'+index"  :val="equip.equipCode" :checkboxMsg="equip.itemName" :isPropChecked="false" ></house-checkbox> -->
                        </div>
                    </div>
                    <div class="rent-include">
                        <label class="button-font input-label">
                            <div class="title">
                                特色標籤 ( 最多選擇 6 個 )
                            </div>
                        </label>
                        <div class="wrap">
                            <house-checkbox v-model="houseFeature" v-for="(feature, index) in houseFeatures" :key="index"  :val="feature.featureCode" :checkboxMsg="feature.itemName" :isPropChecked="feature.check" ></house-checkbox>
                        </div>
                    </div>
                    <div class="rent-include" v-if="rulesInContract.length">
                        <label class="button-font input-label">
                            <div class="title">
                                使用規範 ( 會寫入合約內 )
                            </div>
                        </label>
                        <div class="wrap">
                            <span v-for="(item, index) in rulesInContract" :key="index">
                                {{item}}{{rulesInContract.length-1 === index?'':'、'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="house-description-title" slot="toogle-title">
                起租日設定
            </div>
            <div class="biz-edit-lease-setting" slot="toogle-body">
                <div class="section-two">
                    <div class="lease-info" v-if="rentPeriodList.length">
                        目前此房源有 {{rentPeriodList.length}} 個租約，分別為：
                        <div v-for="(item, index) in rentPeriodList" :key="index">
                            {{getFormatDateTime(item.contractBeginTime)}} - {{getFormatDateTime(item.contractEndTime)}}
                        </div>
                    </div>
                    <div class="house-setting">
                        <div class="house-special">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    最短租期
                                </div>
                                <span v-show="error.shortestPeriodErr" class="error-with-title">{{error.shortestPeriodErr}}</span>
                            </label>
                            <div class="input-arear">
                                <rent-select :class="{error: error.shortestPeriodErr}" refName="shortestPeriod" :selectMsg="editHouse.shortestPeriod?transShortestPeriod(editHouse.shortestPeriod):'請選擇最短租期'" :isEdit="editHouse.shortestPeriod?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                    <ul>
                                        <li v-for="(date, index) in houseConfig.shortestPeriod" :key="index" :data-id="date.code">
                                            {{date.name}}
                                        </li>
                                    </ul>
                                </rent-select>
                            </div>
                        </div>
                        <div class="move-in-date">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    最快起租日
                                </div>
                                <span v-show="error.moveInDateErr" class="error-with-title">{{error.moveInDateErr}}</span>
                            </label>
                            <div class="input-arear">
                                <date-picker v-model="editHouse.moveInDate" :class="{'active': editHouse.moveInDate && !error.moveInDateErr, 'error': error.moveInDateErr}" :placeholder="editHouse.moveInDate?getFormatDate(editHouse.moveInDate):'請選擇日期'" :disabled-date="notBeforeThisday" format="YYYY-MM-DD" valueType="format"></date-picker>
                                <div class="tips-group">
                                    <div class="input-note" @mouseenter="tipStatus.moveInDate=true" @mouseleave="tipStatus.moveInDate=false">最快起租日是什麼？</div>
                                    <border-tips style="top: 22px;" v-if="tipStatus.moveInDate" msg="最快可出租日期，如為出租中房源，可設定租約到期日之後，提供房客預先訂房。" width="424px"></border-tips>
                                    <!-- <div class="contract-data-alarm" v-if="houseDefault.contractBeginTime && houseDefault.contractEndTime">
                                        上個合約租期：{{houseDefault.contractBeginTime?getFormatDateTime(houseDefault.contractBeginTime):''}} - {{houseDefault.contractEndTime?getFormatDateTime(houseDefault.contractEndTime):''}}
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="house-description-title" slot="toogle-title">
                房源說明
            </div>
            <div class="house-description-wrap" slot="toogle-body">
                <span class="title-description">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    僅接受 jpg、png，每張不得超過 5ＭＢ，建議尺寸 300 x 400 px，內容圖限上傳十張
                </span>
                <div class="biz-edit-house-description">
                    <edit-img :imgError="error.imgErr" :imgCoverError="error.imgCoverErr" :imgChangeCoverError="error.imgCoverNotChangeErr"></edit-img>
                    
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="house-description-title" slot="toogle-title">
                上傳影片
            </div>
            <div class="house-description-wrap" slot="toogle-body">
                <span class="title-description">
                    <img src="@/assets/img/icon/info_gray.svg" alt="">
                    上傳案件影片讓房客找房更方便，增加成交機率，影片時間建議不要超過兩分鐘
                </span>
                <div class="biz-add-house-description">
                    <upload-video @setVideoInfo="setVideoInfo" :isEdit="true" :normalFilm="houseDefault.normalFilm" :lastFilm="houseDefault.lastFilm"></upload-video> 
                </div>
            </div>
        </toogle-block>
        <!-- <toogle-block>
            <div class="toogle-title policy" slot="toogle-title">
                <div class="title-group">
                    自訂合約條款
                    <word-tips-hover data="可由房源管理進入自訂合約條款新增及編輯；勾選的條款將會帶入此房源【房屋租賃電子合約書】其他約定條款中。" width="400px"></word-tips-hover>
                </div>
                <div class="view-default">
                    <router-link :to="{ name: 'bizDefaultPolicy'}" target="_blank">
                        <img src="@/assets/img/icon/view_gray.svg" alt="">
                        預設條款
                    </router-link>
                </div>
            </div>
            <div class="toogle-body" slot="toogle-body">
                <policy-checkbox v-model="housePolicyComputed" v-for="(housePolicy, index) in housePolicies" :key="index" val="1" :policyId="housePolicy.policySettingCid" :checkboxMsg="housePolicy.policySettingContent" :isPropChecked="housePolicy.policyUsed" ></policy-checkbox>
                <div class="unset-policy" v-if="housePolicies.length ==0">
                    尚未新增合約條款
                    <button class="new-item-btn" @click="toOtherPage('bizEditPolicy', '新增合約條款')">
                        新增合約條款
                        <img src="@/assets/img/icon/arror_right_gray.svg" alt="" srcset="">
                    </button>
                </div>
            </div>
        </toogle-block> -->
        <toogle-block>
            <div class="toogle-title contract-version" slot="toogle-title">
                <div class="title-group">
                    選擇合約版本
                    <word-tips-hover data="您可以至企業設置 > 合約版本，新增合約版本，也可以使用預設合約，企業在簽名之前仍可以選擇其他合約。" width="400px"></word-tips-hover>
                </div>
                <div class="group">
                    <button class="refresh" v-if="status.isShowReloadBtn" @click="status.reloadContractVertion++, status.isShowReloadBtn=false">
                        <img src="@/assets/img/icon/refresh.svg" alt="">
                        更新合約版本
                    </button>
                </div>
            </div>
            <div class="toogle-body" slot="toogle-body">
                <choose-contract-version v-model="editHouse.contractVersionId" :isEdit="true" @edit="status.isShowReloadBtn=true" :reload="status.reloadContractVertion"></choose-contract-version>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                選擇分群與負責業務
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="area-and-principal">
                    <!-- <div class="no-result" v-if="groupList.length == 0">
                        尚未新增分區群組
                        <div class="new-item-btn">
                            新增分區群組
                            <img src="@/assets/img/icon/arror_right_gray.svg" alt="" srcset="">
                        </div>
                    </div> -->
                    <div class="no-auth" v-if="groupList.length == 0">
                        尚未新增分區群組
                    </div>
                    <div v-else class="select-area">
                        <div>
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    業務分群
                                </div>
                                <span v-show="error.groupIdErr" class="error-with-title">{{error.groupIdErr}}</span>
                            </label>
                            <div class="input-arear" >
                                <div v-if="houseDefault.arrears" @click="eventRules('arrears', '當房源有欠款時，不得更換業務分群')" class="not-allow"></div>
                                <rent-select-filter :class="{error: error.groupIdErr}" class="select-scroll biz" refName="group" :selectMsg="houseDefault.groupName?houseDefault.groupName:'請選擇分區群組'" :isEdit="houseDefault.groupName?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="isDefault">
                                   <div class="select-filter">
                                        <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                        <input v-model="filter.group" placeholder="搜尋業務分群" type="text">
                                    </div>
                                    <ul>
                                        <li v-for="(item, index) in filterGroup" :key="index" :data-id="item.id">
                                            {{item.groupName}}
                                        </li>
                                        <div class="create-tips" @click="toOtherPage('bizAddOrganizationGroup', '建立業務分群')">
                                            建立業務分群
                                            <img src="@/assets/img/icon/arror_right_blue.svg" alt="">
                                        </div>
                                    </ul>
                                </rent-select-filter>
                            </div>
                        </div>
                        <div>
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill">*</span>
                                    業務
                                </div>
                                <span v-show="error.agentCidErr" class="error-with-title">{{error.agentCidErr}}</span>
                            </label>
                            <div class="input-arear">
                                <div v-if="houseDefault.arrears" @click="eventRules('arrears', '當房源有欠款時，不得更換業務')" class="not-allow"></div>
                                <rent-select-filter :class="{error: error.agentCidErr}" class="select-scroll biz" refName="member" :selectMsg="sales.sales.msg" :isEdit="houseDefault.agentName?true:false" @getId="getSelectId"  bgColor="#fff" :setDefault="sales.sales.state">
                                    <div class="select-filter">
                                        <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                        <input v-model="filter.agent" placeholder="搜尋業務" type="text">
                                    </div>
                                    <ul>
                                        <li v-for="(item, index) in filterAgent" :key="index" :data-id="item.userCid" :data-name="item.name">
                                            {{item.name}}
                                        </li>
                                        <div class="create-tips" @click="toOtherPage('bizAddAccount', '建立業務')">
                                            建立業務
                                            <img src="@/assets/img/icon/arror_right_blue.svg" alt="">
                                        </div>
                                    </ul>
                                </rent-select-filter>
                                <div class="input-note" @mouseenter="tipStatus.agent=true" @mouseleave="tipStatus.agent=false">業務姓名會呈現在哪裡？</div>
                                <title-tips v-if="tipStatus.agent" class="tips-agent" title="廣告頁面的聯絡人" width="424px">
                                    <div class="content" slot="content">
                                        <div class="ad-title">
                                            廣告名稱
                                        </div>
                                        <div class="rent">
                                            28,000 <span class="unit">元 / 月</span>
                                        </div>
                                        <div class="agent">
                                            <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                                            <div class="name">業務姓名</div>
                                            <div class="phone">0912345678</div>
                                            <img src="@/assets/img/icon/phone_blue.svg" alt="">
                                        </div>
                                    </div>
                                </title-tips>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                房東資訊
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="landlord-info">
                    <div class="move-in-date">
                        <label class="button-font input-label">
                            <div class="title">
                                房東
                            </div>
                        </label>
                        <div class="input-arear">
                            <div v-if="houseDefault.arrears" @click="eventRules('arrears', '當房源有欠款時，不得更換房東')" class="not-allow"></div>
                            <select-landlord @getLandlordId="setLandlordId" :msg="houseDefault.landlordName?houseDefault.landlordName+'．'+(houseDefault.landlordPhone?houseDefault.landlordPhone:'未輸入電話'):'請選擇房東'"></select-landlord>
                            <div class="input-note" @mouseenter="tipStatus.landlordInfo=true" @mouseleave="tipStatus.landlordInfo=false">房東資訊要用來做什麼？</div>
                            <border-tips v-if="tipStatus.landlordInfo" msg="選擇此房源所屬房東，系統將每月彙整此房東所有房源，提供收支對帳表。" width="424px"></border-tips>
                        </div>
                    </div>
                    <div class="service-fee">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                服務費 %
                            </div>
                            <span v-show="error.serviceFeeRateErr" class="error-with-title">{{error.serviceFeeRateErr}}</span>
                        </label>
                        <div class="input-arear">
                            <input type="text" :class="{error: error.serviceFeeRateErr}" v-model="editHouse.serviceFeeRate" placeholder="請輸入服務費">
                        </div>
                    </div>
                    <upload-landlord-authorization :isEdit="true"></upload-landlord-authorization>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
import selectLandlord from '@/components/bussiness/mgtCategory/houseMgt/addHouse/selectLandlord.vue';
import DatePicker from 'vue2-datepicker';
// import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import HouseCheckbox from '@/components/widge/HouseCheckbox.vue';
import PolicyCheckbox from '@/components/bussiness/widges/tools/PolicyCheckbox.vue';
import billCharge from '@/components/bussiness/mgtCategory/houseMgt/addHouse/billCharge.vue';
import uploadVideo from '@/components/bussiness/mgtCategory/houseMgt/addHouse/uploadVideo.vue';
import EditImg from '@/components/bussiness/mgtCategory/houseMgt/addHouse/EditImg.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import NewPolicy from '@/components/bussiness/widges/tools/NewPolicy.vue';
import addEquips from '@/components/bussiness/widges/modals/addEquips.vue';
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import shareSocialMedia from '@/components/widge/shareSocialMedia.vue';
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import chooseContractVersion from '@/components/bussiness/mgtCategory/houseMgt/addHouse/chooseContractVersion.vue';
import uploadLandlordAuthorization from '@/components/bussiness/mgtCategory/houseMgt/addHouse/uploadLandlordAuthorization.vue';

import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 

import { 
    apiGetCounty,
    apiGetDistrict,
    apiGetRoad,
    apiBizGetContractHouse,
    apiBizGetContractTenant,
    apiBizGetOrganizationGroupList,
    apiBizGetMemberByGroup
} from "@/apis/api.js"; 
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            componentKey: 1,
            contractCid: null,
            tenant: {
                cid: null,
                name: null,
            },
            editHouse: {
                "houseCid": null,
                "name": null,
                "cityCid": null,
                "districtCid": null,
                "roadStreetCid": null,
                "lane": null,
                "alley": null,
                "floor": null,
                "number": null,
                "dash": null,
                "room": null,
                "size": null,
                "houseType": null,
                "buildingType": null,
                "specialType": null,
                "rentMonthly": null,
                "moveInDate": null,
                "shortestPeriod": null,
                "isNumberHidden": false,
                "totalFloor": null,
                "isWithLandlord": null,
                "description": null,
                "equipmentList": [],
                "rentIncludeList": [],
                "ruleList": [],
                "groupId": null,
                "agentCid": null,
                "landlordId": null,
                "serviceFeeRate": null,
                "rentPayDay": null,
                "payByRentPayDay": null,
                "isPublic": null,
                "filmKey": null,
                "contractVersionId": null,
                "billChargeMode": null,
                "housePatternDto": {
                    "bedroom": 0,
                    "sharedRoom": 0,
                    "bathroom": 0,
                    "balcony": 0
                },
                "roomPatternDto": {
                    "hasBalcony": false,
                    "hasDuplex": false
                },
                "editCaseHousePolicyDto": {
                    "policySettingType": 1,
                    "usePolicyDtoList": []
                },
                "editCaseDepositPolicyDto": {
                    "policySettingType": 2,
                    "usePolicyDtoList": []
                },
            },
            isDefault: false,
            address: {
                county: {
                    state: false,
                    msg: '請選擇縣市'
                },
                district: {
                    state: false,
                    msg: '請選擇區域'
                },
                road: {
                    state: false,
                    msg: '請選擇路名'
                }
            },
            sales: {
                group: {
                    state: false,
                    msg: '請選擇業務分群'
                },
                sales: {
                    state: false,
                    msg: '請選擇業務'
                }
            },
            housePattern: false,
            roomPattern: false,
            error: {
                totalFloorErr: '',
                rentMonthlyErr: '',
                sizeErr: '',
                nameErr: '',
                desErr: '',
                numErr: '',
                floorErr: '',
                moveInDateErr: '',
                cityCidErr: '',
                districtCidErr: '',
                roadStreetCidErr: '',
                houseTypeErr: '',
                buildingTypeErr: '',
                shortestPeriodErr: '',
                isWithLandlordErr: '',
                imgErr: false,
                imgCoverErr: false,
                imgCoverNotChangeErr: false,
                groupIdErr: '',
                agentCidErr: '',
                serviceFeeRateErr: '',
                rentPayDayErr: '',
                payByRentPayDayErr: '',
                equipment: [],
                billCharge: '',
                contractVersionId: '',
            },
            modalStatus:{
                globalPolocy: false,
                deleteHouse: false,
                toOtherPage: false,
                editHouse: false,
            },
            tipStatus: {
                landlordInfo: false,
                moveInDate: false,
                agent: false,
                fixedPayWay: false
            },
            filter: {
                road: null,
                group: null,
                agent: null,
            },
            toOtherPageInfo: {
                type: null,
                linkName: null
            },
            status: {
                isDisable: false,
                isShowReloadBtn: false,
                reloadContractVertion: 0
            },
            selectRoad: null,
            groupList: [],
            agentList: [],
            isAgentDefault: false,
            hasTaker: false,
            taskStatus: null,
            featureListCount: 0
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent('編輯房源', { screen_name: '編輯房源'})
        this.getGroupList()
        this.$store.dispatch('setBizHouseCid',  this.$route.query.cid)
        .then(() => {
            this.$store.dispatch('getBizEditHouseDefault')
            .then(() => {
                if(this.houseDefault.cityName != undefined){
                    this.getCounty(this.houseDefault.cityName)
                    this.autoGrow()
                }
            }) 
        })
        this.$store.dispatch('getHouseConfig')
        this.getHouseInfo(this.$route.query.cid)
        // this.notBeforeThisday()
    },
    watch: {
        houseDefault: {
            handler: function (newValue, oldValue) {
                newValue.dash = newValue.dash?newValue.dash:''
                newValue.alley = newValue.alley?newValue.alley:''
                this.editHouse.houseCid = newValue.houseCid
                this.editHouse.name = newValue.name
                this.editHouse.lane = newValue.lane
                this.editHouse.alley = newValue.alley
                this.editHouse.dash = newValue.dash
                this.editHouse.groupId = newValue.groupId
                this.editHouse.agentCid = newValue.agentCid
                this.sales.sales.msg = newValue.agentName?newValue.agentName:'請選擇業務'
                this.editHouse.landlordId = newValue.landlordId
                this.editHouse.serviceFeeRate = newValue.serviceFeeRate
                this.editHouse.payByRentPayDay = newValue.payByRentPayDay
                this.editHouse.rentPayDay = newValue.rentPayDay
                this.editHouse.contractVersionId = newValue.contractVersionId


                if(newValue.floor != undefined && newValue.floor != 0){
                    this.editHouse.floor = newValue.floor
                }else{
                    this.editHouse.floor = ''
                }
                this.editHouse.number = newValue.number
                this.editHouse.room = newValue.room
                if(newValue.size != undefined && newValue.size != 0){
                    this.editHouse.size = newValue.size
                }else{
                    this.editHouse.size = ''
                }
                if(newValue.houseType != undefined && newValue.houseType != 0  && newValue.houseType < 4){
                    this.editHouse.houseType = newValue.houseType
                }
                if(newValue.buildingType != undefined && newValue.buildingType != 0 && newValue.buildingType < 5){
                    this.editHouse.buildingType = newValue.buildingType
                }
                if(newValue.specialType != undefined ){
                    this.editHouse.specialType = newValue.specialType
                }
                if(newValue.rentMonthly != undefined && newValue.rentMonthly != 0){
                    this.editHouse.rentMonthly = newValue.rentMonthly
                }else{
                    this.editHouse.rentMonthly = ''
                }
                if(newValue.moveInDate != undefined && newValue.moveInDate != null){
                    this.editHouse.moveInDate = newValue.moveInDate
                }
                if(newValue.shortestPeriod != undefined && newValue.shortestPeriod != 0){
                    this.editHouse.shortestPeriod = newValue.shortestPeriod
                }
                if(newValue.isNumberHidden != undefined){
                    this.editHouse.isNumberHidden = newValue.isNumberHidden
                }
                if(newValue.totalFloor != undefined && newValue.totalFloor != 0){
                    this.editHouse.totalFloor = newValue.totalFloor
                }else{
                    this.editHouse.totalFloor = ''
                }
                if(newValue.isWithLandlord != undefined){
                    this.editHouse.isWithLandlord = newValue.isWithLandlord
                }
                if(newValue.description != undefined){
                    this.editHouse.description = newValue.description
                }
                
                if( newValue.housePatternDto != undefined ){
                    this.editHouse.housePatternDto.bedroom = newValue.housePatternDto.bedroom
                    this.editHouse.housePatternDto.bathroom = newValue.housePatternDto.bathroom
                    this.editHouse.housePatternDto.balcony = newValue.housePatternDto.balcony
                    this.editHouse.housePatternDto.sharedRoom = newValue.housePatternDto.sharedRoom
                }
                if( newValue.roomPatternDto != undefined){
                    this.editHouse.roomPatternDto.hasBalcony = newValue.roomPatternDto.hasBalcony
                    this.editHouse.roomPatternDto.hasDuplex = newValue.roomPatternDto.hasDuplex
                }
                // this.counties.map( (county, index) => {
                //     if(county == newValue.cityName){
                //         this.editHouse.cityCid = index+1
                //         this.address.county.msg = newValue.cityName
                //         this.$store.dispatch('getDistrict', index+1)
                //     }
                // })
                // this.districts.map( (district, index) => {
                //     if(district.districtName == newValue.districtName){
                //         this.editHouse.districtCid = district.districtCid
                //         this.address.district.msg = newValue.districtName
                //         this.$store.dispatch('getRoad', district.districtCid)
                //         this.address.district.state = true
                //     }
                // })
                // // setTimeout(() => {
                //     this.roads.map( (road, index) => {
                //         if(road.roadStreetName == newValue.roadStreetName){
                //             console.log(newValue.roadStreetName)
                //             this.editHouse.roadStreetCid = road.roadStreetCid
                //             this.address.road.msg = newValue.roadStreetName
                //             this.address.road.state = true
                //         }
                //     })
                // // }, 500)
            },
            deep: true,
            // immediate: true
        },
        editHouse: {
            handler: function (newValue, oldValue){
                let numerical = /^[0-9]*$/,
                    decimalNum = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
                
                // console.log(newValue.description)
                // console.log(newValue.description.length)
                if(newValue.agentCid){
                    this.error.agentCidErr = ''
                }
                if(newValue.groupId){
                    this.error.groupIdErr = ''
                }
                if(newValue.name){
                    if(newValue.name.length < 6 ){
                        this.error.nameErr = '廣告標題需滿6個字'
                    }else if(newValue.name.length > 20){
                        this.error.nameErr = '廣告標題20字以內'
                    }else{
                        this.error.nameErr = ''
                    }
                }
                if(newValue.totalFloor){
                    // 總樓層
                    if( numerical.test(newValue.totalFloor) ){
                        this.error.totalFloorErr = ''
                    }else{
                        this.error.totalFloorErr = '請輸入數字'
                    }
                }
                if(newValue.rentMonthly){
                    // 房租
                    if( numerical.test(newValue.rentMonthly) ){
                        this.error.rentMonthlyErr = ''
                    }else{
                        this.error.rentMonthlyErr = '請輸入數字'
                    }
                }
                if(newValue.size){
                    var decimal = /^[0-9]+(\.[0-9]?)?$/;
                    if(decimal.test(newValue.size)){
                        this.error.sizeErr = ''
                    }else{
                        this.error.sizeErr = '請輸入小數1位內'
                    }
                }
                if(newValue.description.length > 2000){
                    this.error.desErr = '字數限制2000以內'
                }else if(newValue.description){
                    this.autoGrow()
                    this.error.desErr = ''
                } 
                if(newValue.houseType){
                    this.error.houseTypeErr = ''
                }
                if(newValue.buildingType){
                    this.error.buildingTypeErr = ''
                }
                if(newValue.specialType != null){
                    this.error.specialTypeErr = ''
                }
                if(newValue.shortestPeriod){
                    this.error.shortestPeriodErr = ''
                }
                if(newValue.cityCid){
                    this.error.cityCidErr = ''
                }
                if(newValue.districtCid){
                    this.error.districtCidErr = ''
                }
                if(newValue.roadStreetCid){
                    this.error.roadStreetCidErr = ''
                }
                if(newValue.number){
                    this.error.numErr = ''
                }
                if(newValue.floor){
                    this.error.floorErr = ''
                }
                if(newValue.moveInDate){
                    this.checkMoveInDate(newValue.moveInDate)
                }
                if(newValue.isWithLandlord != null){
                    this.error.isWithLandlordErr = ''
                }
                if(newValue.payByRentPayDay != null){
                    this.error.payByRentPayDayErr = ''
                }
                if(newValue.payByRentPayDay === false || newValue.rentPayDay){
                    this.error.rentPayDayErr = ''
                }
                if(newValue.equipmentList.length){
                    newValue.equipmentList.forEach(item=>{
                        if(item.check){
                            if(item.count === null){
                                item.count = 1
                            }
                        }else{
                            item.count = null
                        }
                    })
                }
                this.$store.dispatch('setBizEditHouseList',this.editHouse)
            },
            deep: true
        },
        houseRentInclude: {
            handler: function (newValue, oldValue) {
                this.editHouse.rentIncludeList = newValue
                this.$store.dispatch('setBizEditHouseList',this.editHouse)
                for (let i = 0; i < newValue.length; i++) {
                    const element = newValue[i];
                    // console.log(element.itemName+element.check)
                    if(element.check){
                        this.removeBillCharge(element.itemName)
                    }
                }
            },
            deep: true
        },
        houseEquips: {
            handler: function (newValue, oldValue) {
                this.editHouse.equipmentList = newValue
                this.$store.dispatch('setBizEditHouseList',this.editHouse)

            },
            deep: true
        },
        houseFeatures: {
            handler: function (newValue, oldValue) {
                this.editHouse.featureList = newValue
                this.$store.dispatch('setBizEditHouseList',this.editHouse)
            },
            deep: true
        },
        hasImage: function () {},
        hasCover: function () {},
        hasDefaultCover: function () {},
    },
    methods: {
        setBillChargeError: function (value){
            this.error.billCharge = value
        },
        transShortestPeriod: function (val) {
            let shortestPeriod = this.houseConfig.shortestPeriod

            for (let i = 0; i < shortestPeriod.length; i++) {
                const element = shortestPeriod[i];
                if(element.code == val){
                    return element.name
                }
                
            }
        },
        checkMoveInDate: function (date) {
            // console.log('checkMoveInDate')
            // console.log('date:'+date)
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            let shortestDay = parseInt(this.editHouse.shortestPeriod)
            let startDate = new Date(new Date(date).getTime() -28800000)
            let endDate = new Date(new Date(date).getTime() -28800000)
            endDate = endDate.setMonth(endDate.getMonth() + shortestDay)
            // console.log('endDate',endDate)
            if(startDate){
                this.error.moveInDateErr = ''
                for (let i = 0; i < this.rentPeriodList.length; i++) {
                    const element = this.rentPeriodList[i];
                    // console.log('today:'+today)
                    // console.log('startDate:'+startDate)
                    // console.log('contractBeginTime:'+element.contractBeginTime)
                    // console.log('contractEndTime:'+element.contractEndTime)
                    // console.log('endDate:'+endDate)
                    // console.log('element.contractBeginTime <= endDate:'+element.contractBeginTime <= endDate)
                    // console.log('endDate <= element.contractEndTime:'+endDate <= element.contractEndTime)
                    if(startDate < today){
                        this.error.moveInDateErr = '最快起租日不能早於今日'
                        return
                    }else if(element.contractBeginTime <= endDate && endDate <= element.contractEndTime || element.contractBeginTime <= startDate && startDate <= element.contractEndTime || element.contractBeginTime >= startDate && endDate >= element.contractEndTime){
                        this.error.moveInDateErr = '最快起租日與租約衝突，請調整起租日或最短租期'
                        return
                    }else{
                        this.error.moveInDateErr = ''
                    }
                }
            }
            
            // console.log('currentDay', currentDay)
            // console.log('dateDiff', dateDiff)
        },
        setNewEquips: function (value) {
            this.editHouse.equipmentList.push({
                check: true,
                itemName: value.name,
                count: value.count?value.count:0
            })
        },
        dateDiff: function (sDate1, sDate2) {
            var oDate1 = new Date(sDate1);
            var oDate2 = new Date(sDate2);
            var iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); // 把相差的毫秒數轉換為天數
            return iDays;
        },
        autoGrow: function (){
            let textarea = document.getElementById('edit-description')
            let adjustedHeight=textarea.clientHeight;

            adjustedHeight=Math.max(textarea.scrollHeight,adjustedHeight);
            // if (adjustedHeight>textarea.clientHeight){
                textarea.style.height=adjustedHeight+'px';
            // }

        },
        eventRules: function (event, msg) {
            // let arrears = true
            let arrears = this.houseDefault.arrears
            if(arrears && event === 'arrears'){
                this.$store.dispatch('setAlarmStatus', {status: true,title: msg,type: 'error', closeBtn: true})
            }
        },
        toOtherPage: function (linkName, type) {
            this.toOtherPageInfo.type = type
            this.toOtherPageInfo.linkName = linkName
            if(this.editHouse.name.length > 5 && this.editHouse.name.length < 21 && this.error.nameErr == ''){
                this.modalStatus.toOtherPage = true
                this.openModal()
            }else{
                this.$router.push({name: linkName})
            }
        },
        toOtherPageSave: function (linkName){
            this.$store.dispatch('saveBizEditHouseNoReview', this.editHouse)
            .then(() =>{
                this.$router.push({name: linkName})
            })
        },
        openModal: function (type) {
            if(type == 'deleteHouse'){
                if(this.houseDefault.arrears){
                    this.eventRules('arrears', '當房源有欠款時，不得刪除')
                }else{
                    this.modalStatus.deleteHouse = true
                }
            }else if(type == 'toOtherPage'){
                this.modalStatus.toOtherPage = true
            }else if(type == 'editHouse'){
                this.modalStatus.editHouse = true
            }
        },
        closeModal: function (type) {
            if(type == 'deleteHouse'){
                this.modalStatus.deleteHouse = false
            }else if(type == 'toOtherPage'){
                this.modalStatus.toOtherPage = false
            }else if(type == 'editHouse'){
                this.modalStatus.editHouse = false
            }
        },
        previewHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('預覽房源', { screen_name: '預覽房源'})
            let routeData = this.$router.resolve({name: 'previewHouse', query: {cid: houseCid, mode: 'preview'}});
            window.open(routeData.href, '_blank');
        },
        setLandlordId: function (value){
            this.editHouse.landlordId = value
        },
        getSelectId: function (value) {
            let targetId = event.target.dataset.id
            if( value.ref == 'houseType' ){
                this.componentKey += 1
                this.roomPattern = true
                this.housePattern = true
                this.editHouse.houseType = targetId
            }else if( value.ref == 'buildingType'){
                this.editHouse.buildingType = targetId
            }else if ( value.ref == 'specialType' ){
                this.editHouse.specialType = targetId
            }else if( value.ref == 'shortestPeriod' ){
                this.editHouse.shortestPeriod = targetId
            }else if( value.ref == 'bedroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.bedroom = targetId
            }else if( value.ref == 'bathroom' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.bathroom = targetId
            }else if( value.ref == 'sharedRoom' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.sharedRoom = targetId
            }else if( value.ref == 'balcony' ){
                this.roomPattern = false
                this.housePattern = false
                this.editHouse.housePatternDto.balcony = targetId
            }else if( value.ref == 'hasBalcony' ){
                this.roomPattern = false
                this.housePattern = false
                if( event.target.dataset.id == 1){
                    this.editHouse.roomPatternDto.hasBalcony = true
                }else{
                    this.editHouse.roomPatternDto.hasBalcony = false
                }
            }else if( value.ref == 'hasDuplex' ){
                this.roomPattern = false
                this.housePattern = false
                if( targetId == 1){
                    this.editHouse.roomPatternDto.hasDuplex = true
                }else{
                    this.editHouse.roomPatternDto.hasDuplex = false
                }
            }else if( value.ref == 'isWithLandlord' ){
                if( event.target.dataset.id == 1){
                    this.editHouse.isWithLandlord = true
                }else{
                    this.editHouse.isWithLandlord = false
                }
            }else if ( value.ref == 'county' ){
                this.address.district.state = false

                this.editHouse.cityCid = parseInt(targetId)+1
                this.address.county.msg = event.target.dataset.name
                this.address.district.msg = '請選擇區域'
                this.address.road.msg  = '請選擇路段'
                this.address.road.state = true
                this.address.district.state = true
                this.editHouse.districtCid = null
                this.editHouse.roadStreetCid = null
                

                this.$store.dispatch('getDistrict',(parseInt(targetId)+1))
            }else if ( value.ref == 'district' ){
                this.editHouse.districtCid = parseInt(targetId)
                this.address.district.msg = event.target.dataset.name
                this.address.road.msg  = '請選擇路段'
                this.address.road.state = true
                this.address.district.state = false
                this.editHouse.roadStreetCid = null
                this.$store.dispatch('getRoad',parseInt(targetId))
            }else if ( value.ref == 'road' ){
                this.editHouse.roadStreetCid = parseInt(targetId)
                this.address.road.msg = event.target.dataset.name
                this.address.road.state = false
            }else if ( value.ref == 'group' ){
                this.editHouse.groupId = targetId
                this.editHouse.agentCid = null
                this.sales.sales.msg = '請選擇業務'
                this.sales.sales.state = true
                this.getAgentList(targetId)
                this.isAgentDefault = true
            }else if ( value.ref == 'member' ){
                this.editHouse.agentCid = parseInt(targetId)
                this.sales.sales.msg = event.target.dataset.name
                this.sales.sales.state = false
            }else if( value.ref == 'payway'){
                if(targetId === 'date'){
                    this.editHouse.payByRentPayDay = true
                }else if(targetId === 'contract'){
                    this.editHouse.payByRentPayDay = false
                }
            }else if( value.ref == 'date'){
                this.editHouse.rentPayDay = parseInt(targetId)
            }
        },
        setIsWithLandLord: function () {
            let isWithLanLord = this.editHouse.isWithLandlord
            if( isWithLanLord == null){
                return '請選擇屋主是否同住'
            }else if(isWithLanLord == true){
                return '是'
            }else if(isWithLanLord == false){
                return '否'
            }else{
                return '請選擇屋主是否同住'
            }
        },
        setVideoInfo: function(val){
            if(!val) return
            this.editHouse.isPublic = val.isPublic
            this.editHouse.filmKey = val.filmId
        },
        getHouseInfo: function (hid) {
            const data = {
                houseCid: hid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then( res => {
                console.log(res)
                if(res.data.status = 'SUCCESS'){
                    this.contractCid = res.data.result.houseDetail.contractCid
                    this.hasTaker = res.data.result.houseDetail.taskTaker
                    this.taskStatus = res.data.result.houseDetail.taskStatus
                    if(this.contractCid){
                        this.getContractDetail()
                        this.getContractTenant()
                    }
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getContractTenant: function () {
            let data = this.contractCid
            apiBizGetContractTenant(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.tenant.cid = res.data.result.tenantCid
                    this.tenant.name = res.data.result.tenantName
                }else{
                    this.alart.fail = true
                    this.msg.error = res.data.errorMsg
                    this.errorCode = res.data.errorCode
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContractDetail: function (){
            let data = this.contractCid
            apiBizGetContractHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // this.contractDetail.isPaperContract = res.data.result.isPaperContract
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        saveEditHouse: function () {
            this.$analyticsBiz.logEvent('儲存並上架', { screen_name: '儲存並上架'})
                if(this.checkInput()){
                    this.status.isDisable = true
                    if(this.houseStatus === 3 && this.houseDefault.contractEndTime > new Date(this.editHouse.moveInDate).getTime()){
                        this.modalStatus.editHouse = true
                        return false
                    }
                    // this.editHouse.alley = this.editHouse.alley?this.editHouse.alley:0
                    this.editHouse.editCaseHousePolicyDto.usePolicyDtoList = this.housePolicies
                    this.editHouse.editCaseDepositPolicyDto.usePolicyDtoList = this.despositPolicies
                    // console.log(this.editHouse)
                    this.$store.dispatch('setBizSaveType', 'REVIEW')
                    this.$store.dispatch('setLoadingState', 1)
                    this.$store.dispatch('saveBizEditHouse', this.editHouse)
                    .then(() =>{
                        setTimeout(()=>{
                            this.status.isDisable = false
                            this.$router.push({ name: 'bizHouseMgtDefault'})
                            this.$store.dispatch('setAlarmStatus', {status: true,title: '編輯房源成功',type: 'success'})
                        }, 3000)
                        // this.$store.dispatch('setLoadingState', 0)
                    })
                    .catch(err => {
                        this.status.isDisable = false
                    })
                }
            
        },
        saveEditHouseNoReview: function () {
                this.$analyticsBiz.logEvent('僅儲存', { screen_name: '僅儲存'})
                this.editHouse.editCaseHousePolicyDto.usePolicyDtoList = this.housePolicies
                this.editHouse.editCaseDepositPolicyDto.usePolicyDtoList = this.despositPolicies
                if(this.complete ){
                    if(this.checkInput('NO_REVIEW')){
                        // console.log(this.editHouse)
                        this.$store.dispatch('setBizSaveType', 'NO_REVIEW')
                        this.$store.dispatch('setLoadingState', 1)
                        this.$store.dispatch('saveBizEditHouseNoReview', this.editHouse)
                        .then(() =>{
                            if(this.$route.query.type === 'econtract'){
                                this.$router.push({ name: 'bizNewEContract'})
                            }else if(this.$route.query.type === 'contract'){
                                this.$router.push({ name: 'bizNewPaperContract'})
                            }else if(this.$route.query.type === 'renewal'){
                                this.$router.push({name: 'bizRenewalContract', query: {contractCid: this.$route.query.contractCid}})
                            }else{
                                this.$router.push({ name: 'bizHouseMgtDefault'})
                                this.$store.dispatch('setAlarmStatus', {status: true,title: '編輯房源成功',type: 'success'})
                            }
                            this.status.isDisable = false
                        })
                        .catch(err => {
                            this.status.isDisable = false
                        })
                    }
                }else{
                    if(this.noReviewCheckInput()){
                        console.log('no-review')
                        this.$store.dispatch('setBizSaveType', 'NO_REVIEW')
                        this.$store.dispatch('setLoadingState', 1)
                        this.$store.dispatch('saveBizEditHouseNoReview', this.editHouse)
                        .then(() =>{
                                this.$router.push({ name: 'bizHouseMgtDefault'})
                                this.$store.dispatch('setAlarmStatus', {status: true,title: '編輯房源成功',type: 'success'})
                                this.status.isDisable = false
                        })
                        .catch(err => {
                            this.status.isDisable = false
                        })
                    }
                    
                }
                

        },
        deleteHouse: function () {
            this.$store.dispatch('deleteBizEditHouse', this.$route.query.cid)
            .then( () => {
                this.$store.dispatch('setApiStatus', 'update')
                this.$router.push({ name: 'bizHouseMgtDefault'})

            });
        },
        setPublish: function (status) {
            this.$analyticsBiz.logEvent("下架");
            this.$store.dispatch('setBizEditPublish', status)
        },
        notBeforeThisday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            let contractPeriod = this.rentPeriodList
            if(contractPeriod.length){
                for (let i = 0; i < contractPeriod.length; i++) {
                    const period = contractPeriod[i];
                    if(period.contractBeginTime-86400000 < date &&  period.contractEndTime+28800000 > date || today > date){
                        return true
                    }
                }
            }else{
                return today > date
            }
        },
        // autoGrow: function (){
        //     // console.log(event.target)
            
        //     let textarea = document.getElementById('edit-description')
        //     let pre = document.getElementsByClassName('pre')
        //     pre[0].innerHTML = textarea.value
        //     // var adjustedHeight=textarea.clientHeight;

        //     // adjustedHeight=Math.max(textarea.scrollHeight,adjustedHeight);
        //     // if (adjustedHeight>textarea.clientHeight){
        //     //     textarea.style.height=adjustedHeight+'px';
        //     // }

        // },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        noReviewCheckInput (){
            if(!this.editHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            // if(this.editHouse.billChargeMode.length){
            //     for (let i = 0; i < this.editHouse.billChargeMode.length; i++) {
            //         const element = this.editHouse.billChargeMode[i];
            //         if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
            //             this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
            //             this.error.billCharge = true
            //             return
            //         }
            //     }
            // }
            if(
                this.editHouse.name.length > 5 &&
                this.editHouse.name.length < 21 &&
                this.error.nameErr == '' 
                // !this.error.billCharge
            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        checkInput: function (type) {
            if(type !== 'NO_REVIEW'){
                this.checkMoveInDate(this.editHouse.moveInDate)
                if(this.notBeforeThisday()){
                    if(this.houseStatus == 3){
                        this.error.moveInDateErr = '最快入住日期需晚於合約迄日'
                    }else{
                        this.error.moveInDateErr = '最快入住日期需晚今日'
                    }
                }
            }else{
                this.error.moveInDateErr = ''
            }
            if(!this.hasImage){
                this.error.imgErr = true
            }else{
                this.error.imgErr = false
            }
            if(!this.hasCover){
                this.error.imgCoverErr = true
            }else{
                this.error.imgCoverErr = false
            }
            if(!this.hasDefaultCover){
                this.error.imgCoverNotChangeErr = true
            }else{
                this.error.imgCoverNotChangeErr = false
            }
            if(!this.editHouse.groupId){
                this.error.groupIdErr = '請選擇分區群組'
            }
            if(!this.editHouse.agentCid){
                this.error.agentCidErr = '請選擇負責人'
            }
            if(!this.editHouse.name){
                this.error.nameErr = '房源名稱需滿6個字'
            }
            if(!this.editHouse.rentMonthly){
                this.error.rentMonthlyErr = '請填寫租金'
            }

            if(!this.editHouse.description){
                this.error.desErr = '請填寫房源描述'
            }

            if(!this.editHouse.size){
                this.error.sizeErr = '請填寫坪數'
            }

            if(!this.editHouse.totalFloor){
                this.error.totalFloorErr = '請填寫總樓層'
            }

            if(!this.editHouse.number){
                this.error.numErr = '請填寫完整欄位'
            }

            if(!this.editHouse.floor){
                this.error.floorErr = '請填寫完整欄位'
            }

            if(!this.editHouse.moveInDate){
                this.error.moveInDateErr = '請填寫起租日'
            }
            
            if(!this.editHouse.cityCid){
                this.error.cityCidErr = '請填寫完整欄位'
            }
            if(!this.editHouse.districtCid){
                this.error.districtCidErr = '請填寫完整欄位'
            }
            if(!this.editHouse.roadStreetCid){
                this.error.roadStreetCidErr = '請填寫完整欄位'
            }
            if(!this.editHouse.houseType){
                this.error.houseTypeErr = '請選擇出租類型'
            }
            if(!this.editHouse.buildingType){
                this.error.buildingTypeErr = '請選擇房屋類型'
            }
            if(this.editHouse.specialType == null){
                this.error.specialTypeErr = '請選擇特殊樓層'
            }
            if(!this.editHouse.shortestPeriod){
                this.error.shortestPeriodErr = '請選擇最短租期'
            }
            if(this.editHouse.isWithLandlord == null){
                this.error.isWithLandlordErr = '請選擇屋主是否同住'
            }
            
             if(this.editHouse.payByRentPayDay == null){
                this.error.payByRentPayDayErr = '請選擇繳款方式'
            }
            if(this.editHouse.payByRentPayDay && this.editHouse.rentPayDay == null){
                this.error.rentPayDayErr = '請選擇繳款日'
            }
            if(this.checkEquip.isError){
                this.$store.dispatch('setAlarmStatus', {status: true,title: `提供設備：${this.checkEquip.itemName}不得為空值`,type: 'error'})
                return
            }
            if(this.editHouse.billChargeMode.length){
                for (let i = 0; i < this.editHouse.billChargeMode.length; i++) {
                    const element = this.editHouse.billChargeMode[i];
                    if(element.type !=='PAY_BY_SELF' && !element.amount && !this.isInRentInclude(element.itemName)){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: `${element.itemName}不得為空值`,type: 'error'})
                        this.error.billCharge = true
                        return
                    }
                }
            }
            if(
                this.editHouse.name &&
                this.editHouse.rentMonthly &&
                this.editHouse.description &&
                this.editHouse.totalFloor &&
                this.editHouse.number &&
                this.editHouse.floor &&
                this.editHouse.moveInDate &&
                this.editHouse.districtCid &&
                this.editHouse.roadStreetCid &&
                this.editHouse.houseType &&
                this.editHouse.buildingType &&
                this.editHouse.cityCid &&
                this.editHouse.isWithLandlord != null &&
                this.editHouse.payByRentPayDay != null &&
                this.editHouse.specialType != null &&
                this.editHouse.shortestPeriod &&
                this.editHouse.groupId &&
                this.editHouse.agentCid &&
                !this.checkEquip.isError &&
                this.hasImage &&
                this.hasCover &&
                this.hasDefaultCover &&
                !this.error.billCharge &&
                this.error.totalFloorErr == '' &&
                this.error.rentMonthlyErr == '' &&
                this.error.sizeErr == '' &&
                this.error.nameErr == '' &&
                this.error.desErr == '' &&
                this.error.floorErr == '' &&
                this.error.moveInDateErr == '' &&
                this.error.cityCidErr == '' &&
                this.error.districtCidErr == '' &&
                this.error.roadStreetCidErr == '' &&
                this.error.houseTypeErr == '' &&
                this.error.buildingTypeErr == '' &&
                this.error.specialTypeErr == '' &&
                this.error.shortestPeriodErr == '' &&
                this.error.isWithLandlordErr == '' &&
                this.error.groupIdErr == '' &&
                this.error.agentCidErr == '' &&
                this.error.payByRentPayDayErr == '' &&
                this.error.rentPayDayErr == '' &&
                this.error.serviceFeeRateErr == ''
            ){
                return true
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '請確認所有必填欄位都已填寫完畢',type: 'error'})
                return false
            }
        },
        isInRentInclude: function (itemName) {
            for (let i = 0; i < this.houseRentInclude.length; i++) {
                const element = this.houseRentInclude[i];
                if(element.check && element.itemName === itemName){
                    return true
                }
            }
        },
        getEditHouseDefault: function () {
            this.$store.dispatch('getBizEditHousePolicy', this.$route.query.cid)
        },
        closeAlart: function () {
            this.$store.commit('bizEditHouse/set_save_fail', {status: false, msg: ''})
            this.$store.commit('bizEditHouse/set_save_success', {status: false, msg: ''})
        },
        getSpecialType: function (val) {
            if(val == 0){
                return '無'
            }else if(val == 3){
                return '頂樓加蓋'
            }else if(val == 4){
                return '地下室'
            }
        },
        getCounty: function (county) {
            let _self = this
            apiGetCounty()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.data
             
                    for (let i = 0; i < value.length; i++) {
                        const item = value[i];
                        // console.log(item)
                        if( item == county){
                            // console.log(item)
                            _self.editHouse.cityCid = i+1
                            _self.address.county.msg = item
                            _self.address.county.state = true
                            _self.$store.dispatch('getDistrict', i+1)
                            .then( () => {
                                _self.getDistrict(i+1)
                            })
                            return
                        }else{
                            _self.editHouse.cityCid = null
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getDistrict: function (data) {
            let _self = this
            apiGetDistrict(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.districtVoList
                 
                    for (let i = 0; i < value.length; i++) {
                        const item = value[i];
                        if( item.districtName == _self.houseDefault.districtName ){
                            _self.editHouse.districtCid = item.districtCid
                            _self.address.district.msg = item.districtName
                            this.componentKey += 1
                            _self.$store.dispatch('getRoad', item.districtCid)
                            .then(()=>{
                                _self.getRoad(item.districtCid)
                            })
                            return
                        }else{
                            _self.editHouse.districtCid = null
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getRoad: function (data) {
            apiGetRoad(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.roadVoList
                    let roadNameTmp = this.houseDefault.roadStreetName
                    for (let i = 0; i < value.length; i++) {
                        const item = value[i];
                        if( item.roadStreetName == roadNameTmp){
                            this.editHouse.roadStreetCid = item.roadStreetCid;
                            this.address.road.msg = roadNameTmp;
                            this.componentKey += 1
                            return
                        }else{
                            this.editHouse.roadStreetCid = null
                            this.address.road.msg = '請選擇路段'
                        }
                    }
                  
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        shareSocialMedia: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'shareSocialMedia'})
        },
        checkOptionRules: function (type, msg) {
            if(type == 'houseType'){
                if(this.editHouse.houseType == null){
                    this.openAlarm(msg)
                }else{
                    return
                }
            }else if(type == 'road'){
                if(this.editHouse.districtCid == null){
                    this.openAlarm(msg)
                }else{
                    return
                }
            }else if(type == 'district'){
                if(this.editHouse.cityCid == null){
                    this.openAlarm(msg)
                }else{
                    return
                }
            }
        },
        openAlarm: function (msg) {
            let alarm = {
                status: true,
                title: msg,
                closeBtn: false,
                type: 'error'
            }
            this.$store.dispatch('setAlarmStatus', alarm)
        },
        getGroupList: function () {
            apiBizGetOrganizationGroupList()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    this.groupList =  res.data.result
                }
            })
            .catch(err => {
            })
        },
        getAgentList: function (id) {
            console.log(id)
            apiBizGetMemberByGroup(id)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.agentList =  res.data.result
                }
            })
            .catch(err => {
            })
        },
        addPercentSign: function () {
            if(this.editHouse.serviceFeeRate != ''){
                this.editHouse.serviceFeeRate = this.editHouse.serviceFeeRate+' %';
            }
        },
        removePercentSign: function () {
            this.editHouse.serviceFeeRate = this.editHouse.serviceFeeRate.replace('%','');
            this.editHouse.serviceFeeRate = this.editHouse.serviceFeeRate.replace(/\s+/g,'');

            return this.editHouse.serviceFeeRate
        },
        setFeaturesCount: function () {
            let features = this.editHouse.featureList,
            count = 0
            features.forEach((item)=>{
                if(item.check){
                    count++
                }
            })
            this.featureListCount = count
        },
        removeBillCharge: function (itemName) {
            const list = this.editHouse.billChargeMode
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                if(element.itemName === itemName){
                    this.editHouse.billChargeMode.splice(i, 1)
                }
                
            }
        }
    },
    computed: {
        checkEquip: function () {
            const list = this.editHouse.equipmentList
            let data = {
                itemName: null,
                isError: false
            }
            list.forEach((item, index) =>{
                if(item.check && !item.count){
                        data.isError = true
                        data.itemName = item.itemName
                        this.error.equipment[index] = true
                }else{
                    this.error.equipment[index] = false
                }
                this.componentKey++
            })
            return data
        },
        hasBalcony: function () {
            let balcony = this.houseDefault.roomPatternDto
            if(  balcony != undefined  && balcony.hasBalcony == true ){
                return '有陽台'
            }else{
                return '無陽台'
            }
        },
        hasDuplex: function () {
            let duplex = this.houseDefault.roomPatternDto
            if(  duplex != undefined  && duplex.hasDuplex == true ){
                return '有閣樓'
            }else{
                return '無閣樓'
            }
        },
        balcony: function () {
            let balcony = this.houseDefault.housePatternDto
            // console.log(balcony)
            if( balcony && balcony != undefined ){
                return balcony.balcony + '陽台'
            }else{
                return '陽台'
            }
        },
        bathroom: function () {
            let bathroom = this.houseDefault.housePatternDto
            if( bathroom && bathroom != undefined ){
                return bathroom.bathroom + '衛浴'
            }else{
                return '衛浴'
            }
        },
        bedroom: function () {
            let bedroom = this.houseDefault.housePatternDto
            if( bedroom && bedroom != undefined ){
                return bedroom.bedroom + '房'
            }else{
                return '房'
            }
        },
        sharedRoom: function () {
            let sharedRoom = this.houseDefault.housePatternDto
            if( sharedRoom && sharedRoom != undefined ){
                return sharedRoom.sharedRoom + '廳'
            }else{
                return '廳'
            }
        },
        houseInclude:{
            get: function () {
                return // ...
            },
            set: function (val) {
                // console.log(val)
                this.houseRentInclude.map( item => {
                    // console.log(val)
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        houseFeature:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseFeatures.map( item => {
                    if( item.itemName == val.name ){
                        if(val.value && this.featureListCount >= 6){
                            this.$store.dispatch('setAlarmStatus', {status: true,title: '特色標籤，最多選擇 6 個',type: 'error'})
                        }else{
                            if( val.value == true ){
                                item.check = true
                            }else{
                                item.check = false
                            }
                        }
                    }
                });
                this.setFeaturesCount()
            }
        },
        houseEquip:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.houseEquips.map( item => {
                    if( item.itemName == val.name ){
                        if( val.value == true ){
                            item.check = true
                        }else{
                            item.check = false
                        }
                    }
                });
            }
        },
        rulesInContract: function() {
            let arr = []
            let features = this.editHouse.featureList

            for (let i = 0; i < features.length; i++) {
                const element = features[i];
                if(element.listInContract){
                    // arr[j] = element
                    if(element.listInContractWhen === 'FEATURE_NOT_SELECTED' && !element.check){
                        arr.push(element.listInContractName)
                    }else if(element.listInContractWhen === 'FEATURE_SELECTED' && element.check){
                        arr.push(element.listInContractName)
                    }
                }
            }
            return arr
        },
        housePolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.housePolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            item.policyUsed = true
                        }else{
                            item.policyUsed = false
                        }
                        
                    }
                });
            }
        },
        despositPolicyComputed:{
            get: function () {
                return // ...
            },
            set: function (val) {
                this.despositPolicies.map( item => {
                    if( item.policySettingCid == val.id ){
                        if( val.value == true ){
                            item.policyUsed = true
                        }else{
                            item.policyUsed = false
                        }
                    }
                });
            }
        },
        filterRoad: function () {
            return this.roads.filter((item) => {
                // console.log(road.roadStreetName)
                if( this.filter.road ){
                    if(item.roadStreetName.includes(this.filter.road)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterGroup: function () {
            return this.groupList.filter((item) => {
                // console.log(road.roadStreetName)
                if( this.filter.group ){
                    if(item.groupName.includes(this.filter.group)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterAgent: function () {
            return this.agentList.filter((item) => {
                // console.log(road.roadStreetName)
                if( this.filter.agent ){
                    if(item.name.includes(this.filter.agent)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            houseFeatures: 'GET_BIZ_EDIT_FEATURES',
            houseEquips: 'GET_BIZ_EDIT_EQUIPS',
            houseRentInclude: 'GET_BIZ_EDIT_RENT_INCLUDE',
            buildingType: 'GET_BIZ_EDIT_BUILDING_TYPE',
            houseType: 'GET_BIZ_EDIT_HOUSE_TYPE',
            specialType: 'GET_BIZ_EDIT_SPECIAL_TYPE',
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
            houseDefault: 'GET_BIZ_EDIT_HOUSE_DEFAULT',
            housePolicies: 'GET_BIZ_EDIT_HOUSE_POLICY',
            despositPolicies: 'GET_BIZ_EDIT_DESPOSIT_POLICY',
            billChargeMode: 'GET_BIZ_EDIT_HOUSE_BILL_CHRAGE_MODE',
            complete: 'GET_BIZ_EDIT_HOUSE_COMPELETE',
            publish: 'GET_BIZ_EDIT_HOUSE_PUBLISH',
            alartError: 'GET_BIZ_EDIT_ERROR_STATE',
            alartSuccess: 'GET_BIZ_EDIT_SUCCESS_STATE',
            hasImage: 'GET_BIZ_EDIT_HOUSE_HAS_IMAGE',
            hasCover: 'GET_BIZ_EDIT_HOUSE_HAS_COVER',
            hasDefaultCover: 'GET_BIZ_EDIT_HOUSE_HAS_CHANGE_COVER',
            houseStatus: 'GET_BIZ_EDIT_HOUSE_STATUS',
            // moveInDateStart: 'GET_BIZ_EDIT_HOUSE_MOVE_IN_DATE_START',
            rentPeriodList: 'GET_BIZ_EDIT_RENT_PERIOD_LIST',
            houseConfig: 'GET_HOUSE_CONFIG'
        })
    },
    components: {
        DatePicker,
        RentSelect,
        RentSelectFilter,
        HouseCheckbox,
        EditImg,
        PolicyCheckbox,
        DotLargeDropMenu,
        Modal,
        NewPolicy,
        AlartMsg,
        shareSocialMedia,
        toogleBlock,
        selectLandlord,
        Checkbox,
        borderTips,
        titleTips,
        wordTipsHover,
        uploadVideo,
        btnLoading,
        addEquips,
        billCharge,
        chooseContractVersion,
        uploadLandlordAuthorization
    }
}
</script>
<style lang="scss">
    .biz-edit-house{
        margin-bottom: 230px;
        #modal.delete-house{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .page-header{
            .btn-group{
                .preview{
                    width: 120px;
                    margin-right: 10px;
                }
                .save{
                    width: 120px;
                    margin-right: 10px;
                }
                .publish{
                    width: 120px;
                    margin-right: 10px;
                }
                .loading-wrap{
                    position: relative;
                    .btn-loading{
                        left: -4px;
                        top: 6px;
                    }
                }
            }
        }
        .not-allow{
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 3;
        }
        .user-info{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                padding: 0 24px;
                height: 100%;
                color: #a8a5a4;
                border-right:1px solid #f1f5f4;
            }
            .group{
                width: 100%;
                padding: 0 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .name{
                    display: flex;
                    align-items: center;
                    margin-right: 18px;
                    img{
                        width: 30px;
                        margin-right: 8px;
                    }
                }
            }
            
        }
        .unit-title{
            display: flex;
            align-items: center;
            font-size: 20px;
            margin-bottom: 30px;
            color: #ff9275
        }
        .select-landlord{
            width: 424px;
        }
        .title-description{
            display: flex;
            align-items: center;
            color: #676362;
            font-size: 14px;
            margin-bottom: 27px;
            img{
                margin-right: 4px;
            }
        }
        // label{
        //     display: block;
        //     font-weight: 500;
        //     margin-bottom: 12px;
        // }
        // input{
        //     margin-bottom: 30px;
        // }
        .biz-rent-select{
            background: #fff;
        }
        .biz-edit-house-description,
        .biz-edit-house-type{
            margin-bottom: 60px;
        }
        .biz-edit-lease-setting{
            margin-bottom: 0px;
        }
        .biz-edit-lease-setting,
        .biz-edit-house-type{
            .section-one{
                .house-address{
                    position: relative;
                    margin-bottom: 14px;
                    display: flex;
                    flex-wrap: wrap;
                    span.error {
                        right: 52px;
                        top: 4px;
                        left: unset;
                        bottom: unset;
                    }
                    .hide-num{
                        position: relative;
                        // top: -4px;
                        margin-left: 0px;
                        margin-bottom: 10px;
                    }
                    .house-address-wrap{
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        label{
                            margin-bottom: 0px;
                        }
                        > div{
                            margin-right: 12px;
                            margin-bottom: 16px;
                        }
                        > div:nth-child(-n+2){
                            width: 170px;
                        }
                        > div:nth-child(n+4){
                            color: #525956;
                            input{
                                width: 174px;
                                margin-bottom: 0px;
                            }
                        }
                        .select-road{
                            width: 174px;
                        }
                    }
                    
                }
            }
            .contract-data-alarm{
                margin-top: 6px;
            }
            .section-two{
                .lease-info{
                    position: relative;
                    width: 1140px;
                    left: -24px;
                    background-color: #fff2f2;
                    color: #fc7171;
                    padding: 16px 25px 18px;
                    margin-bottom: 24px;
                    font-size: 16px;
                    font-weight: 500;
                    box-sizing: border-box;
                    line-height: 1.63;
                }
                .house-description{
                    >div{
                        margin-bottom: 30px;
                    }
                    .house-intro{
                        min-height: 100px;
                        .intro-container{
                            position: relative;
                            min-height: 84px;
                            textarea{
                                position: relative;
                                top: 0px;
                                left: 0px;
                                min-height: 84px;
                                height: 100%;
                                padding: 12px 476px 12px 16px;
                                // background: transparent;
                                outline: 0;
                                resize: none;
                                overflow: hidden;
                            }
                            .des-count{
                                position: absolute;
                                z-index: 2;
                                right: 16px;
                                bottom: 12px;
                                color: #c5c2c1;
                                .count{
                                    color: #292625;
                                }
                            }
                            // .pre{
                            //     display: block;
                            //     visibility: hidden;
                            // }
                        }
                    }
                }
                .house-setting{
                    display: flex;
                    flex-wrap: wrap;
                    > div{
                        position: relative;
                        width: 424px;
                        margin-bottom: 30px;
                    }
                    > div:nth-child(odd){
                        margin-right: 208px;
                    }
                    // .shortest-period span.error,
                    // .is-with-landlord span.error,
                    // .lease-type span.error,
                    // .house-special span.error,
                    // .house-type span.error{
                    //     right: 0;
                    //     top: 2px;
                    //     left: unset;
                    //     bottom: unset;
                    // }
                    // .house-size{
                    //     input{
                    //         width: 390px;
                    //     }
                    // }
                    .house-pattern{
                        .biz-rent-select{
                            box-sizing: border-box;
                        }
                        &.two-items{
                            .biz-rent-select{
                                width: 206px;
                            }
                        }
                        &.four-items{
                            .biz-rent-select{
                                width: 98px;
                            }
                        }
                    }
                    // .house-floor{
                    //     .house-floor-wrap{
                    //         display: flex;
                    //         align-items: center;
                    //         .biz-rent-select{
                    //             width: 206px;
                    //             margin-right: 12px;
                    //         }
                    //         input{
                    //             width: 172px;
                    //             margin-bottom: 0px;
                    //         }
                    //     }
                    // }
                    // .house-total-floor{
                    //     input{
                    //         width: 390px;
                    //     }
                    // }
                    
                }
                .house-equips{
                    position: relative;
                    width: 424px;
                    margin-bottom: 16px !important;
                    justify-content: space-between;
                    &.odd{
                        margin-right: 208px !important;
                    }
                    &.new-equips{
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background-color: #ffffff;
                        height: 42px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                    .input-arear{
                        width: 310px;
                        .quantifier{
                            position: absolute;
                            right: 16px;
                            top: 12px;
                        }
                    }
                }
                .select-date{
                    position: absolute;
                    width: 98px;
                    top: 21px;
                    right: -142px;
                }
                .move-in-date{
                    .mx-datepicker{
                        width: 424px;
                        input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker.error{
                        input{
                            border: solid 1px #fc7171 !important;
                        }
                    }
                    .mx-datepicker:hover{
                        input{
                            border: 1px solid #292625;
                            color: #292625;
                        }
                        i{
                            color: #292625;
                        }
                    }
                    .mx-datepicker.active{
                        input{
                            color: #292625;
                            &::placeholder {
                                color: #292625;
                            }
                            &:-ms-input-placeholder {
                                color: #292625;
                            }
                            
                            &::-ms-input-placeholder {
                                color: #292625;
                            }
                        }
                        i{
                            color: #292625;
                        }
                    }
                }
                .rent-include,
                .equipment,
                .rules{
                    margin-bottom: 18px;
                    .wrap{
                        display: flex;
                        flex-wrap: wrap;
                        > div{
                            margin-bottom: 12px;
                            margin-right: 12px;
                        }
                    }
                }
            }
        }
        .biz-edit-house-policy{
            .house-policy{
                position: relative;
                margin-bottom: 60px;
                .group{
                    position: absolute;
                    display: flex;
                    top: -53px;
                    right: 22px;
                    >div{
                        a{
                            display: flex;
                            align-items: center;
                            >img{
                                margin-right: 4px;
                            }
                        }
                    }
                    .edit{
                        margin-right: 28px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        >img{
                            margin-right: 4px;
                        }
                    }
                }
            }
            .global-policy{
                .modal-content{
                    // width: 1198px;
                    // height: 760px;
                    padding: 0 32px !important;
                    .detail{
                        h1{
                            margin: 30px 0;
                        }
                        // width: 1198px;
                        // height: 760px;
                        overflow-x: hidden;
                    }
                    // .detail::-webkit-scrollbar {
                    //     display: none;
                    // }
                }
                
            }
        }
    }
    .unset-policy{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .new-item-btn{
            width: 148px;
            margin-top: 12px;
        }
    }
    .area-and-principal{
            display: flex;
            align-items: center;
            justify-content: center;
            >div{
                margin-bottom: 20px;
            }
            .no-result{
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .new-item-btn{
                    margin-top: 12px;
                }
            }
            .select-area{
                width: 100%;
                display: flex;
                align-items: center;
                >div{
                    width: 424px;
                }
                >div:first-child{
                    margin-right: 208px;
                }
            }
            .tips-agent{
                font-size: 20px;
                font-weight: 500;
                .ad-title{
                    margin-bottom: 10px;
                }
                .rent{
                    color: #a19d9c;
                    margin-bottom: 16px;
                    .unit{
                        font-size: 14px;
                    }
                }
                .agent{
                    display: flex;
                    align-items: center;
                    .name{
                        color: #fc7171;
                        margin-left: 8px;
                        margin-right: 12px;
                    }
                    .phone{
                        margin-right: 10px;
                        color: #3a455f;
                    }
                }
            }
        }
        .service-fee{
            width: 424px;
        }
        .policy{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            .view-default{
                font-size: 14px;
                color: #676362;
                position: relative;
                right: 45px;
                a{
                    display: flex;
                    align-items: center;
                }
            }
        }
        .landlord-info{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            // align-items: center;
            >div{
                width: 424px;
                margin-bottom: 24px;
            }
            >div:first-child{
                margin-right: 208px;
            }
        }
    // @media screen and (max-width: 1280px) {
    //     .biz-edit-house{
    //         .user-info{
    //             // width: 1142px;
    //         }
    //         // .biz-edit-house-description{
    //         //     width: 1142px;
    //         //     input,
    //         //     textarea
    //         //     {
    //         //         width: 1108px;
    //         //     }
    //         // }
    //     }
    //     .biz-edit-house{
    //         .biz-edit-house-type{
    //             .section-one{
    //                 > div:nth-child(odd) {
    //                     margin-right: 162px;
    //                 }
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/addHouse/EditHouseComp.vue